import React from 'react';
import { connect } from 'react-redux';
import { Modal, Header } from 'semantic-ui-react';
import { showCollectionBreakdownModal, hideVarianceHistoryDetailsModal } from '../../redux/actions/modals';
import DataGrid from '../shared/DataGrid';
import collections from '../../api/collections';

class SiteVarianceHistoryModal extends React.Component {

  state = {
    loading: false
  }

  onRowClick = (row) => {
    const { detailRef } = row;
    if (detailRef && detailRef.length > 0) {
      this.setState({ loading: true }, () => {
        collections.getBankingWeekByEgm(detailRef).then(
          result => {
            this.setState({ loading: false })
            this.props.showCollectionBreakdownModal(
              { detailRef, ...result },
              async () => this.onRowClick(row),
              async () => {
                this.setState({ loading: true }, () => {
                  this.props.modal.onRefresh().then(() => this.setState({ loading: false }))
                })
              },
            );
          },
          error => this.setState({ loading: false })
        );
      });
    }
  }

  onClose = () => {
    this.props.hideVarianceHistoryDetailsModal().then(() => {
      this.props.modal.onClose()
    })
  }

  render() {
    const { open, siteDisplay, machineDisplay } = this.props.modal;
    const { data, rowDef, headerDef } = this.props.modal.grid
    return (
      <Modal
        open={open}
        onClose={this.onClose}
        size='fullscreen'
        closeIcon
        style={{ height: "80%"}}
      >
        <Modal.Header>Variance History Details</Modal.Header>
        <Modal.Content className="h-100 gs-flex-container-vertical">
          <Header size="small">
            { siteDisplay }
            <Header.Subheader>{ machineDisplay }</Header.Subheader>   
          </Header>
          <DataGrid
            loading={this.state.loading}
            headings={headerDef}
            data={data}
            rowDef={rowDef}
            onRowClick={this.onRowClick}
            fullHeight
          />
        </Modal.Content>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.varianceHistoryDetailsModal,
  };
};

export default connect(mapStateToProps, { hideVarianceHistoryDetailsModal, showCollectionBreakdownModal })(SiteVarianceHistoryModal);


